import React from 'react';
import ContactsSection from 'components/ContactsSection/ContactsSection';
import ContactsOrderForm from 'pages/Contacts/components/ContactsOrderForm/ContactsOrderForm';

const Contacts = () => {
  return (
    <>
      <ContactsSection />
      <ContactsOrderForm />
    </>
  );
};

export default Contacts;
